module.exports = __webpack_public_path__ + "img/g4.51ed87e6.jpg";